import moment from 'moment';

import type {DueWithinFilter} from './types';

/**
 * Resolves the classwork toolbar's "Due Within" choice to a concrete window. Shared so both lists
 * the toolbar drives send the server the same bounds.
 */
export const dueWithinBounds = (
  dueWithin: DueWithinFilter,
  customStart: string,
  customEnd: string
): {start: moment.Moment | null; end: moment.Moment | null} => {
  switch (dueWithin) {
    case 'week':
      return {start: moment().startOf('week'), end: moment().endOf('week')};
    case 'month':
      return {start: moment().startOf('month'), end: moment().endOf('month')};
    case 'custom':
      return {
        start: customStart ? moment(customStart).startOf('day') : null,
        end: customEnd ? moment(customEnd).endOf('day') : null
      };
    case 'schoolYear':
    default:
      return {start: null, end: null};
  }
};
